export function isAxiosError(obj) {
    return (obj instanceof Error &&
        'isAxiosError' in obj &&
        typeof obj.isAxiosError === 'boolean' &&
        obj.isAxiosError);
}
export function parseErrorBody(error, i18n) {
    var _a, _b;
    var _c;
    if (isAxiosError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data)) {
        const body = error.response.data;
        switch (body['@type']) {
            case 'hydra:Error': {
                const errorKey = body['hydra:description'];
                const errorMessage = errorKey && i18n.te(`error.${errorKey}`)
                    ? i18n.tc(`error.${errorKey}`)
                    : errorKey || i18n.tc('error.default');
                return { message: errorMessage, cause: error.cause };
            }
            case 'ConstraintViolationList': {
                const fieldErrors = {};
                for (const violation of body.violations || []) {
                    (_b = fieldErrors[_c = violation.propertyPath]) !== null && _b !== void 0 ? _b : (fieldErrors[_c] = []);
                    const errorKey = ERROR_TRANSLATION_KEYS[violation.code];
                    const errorMessage = i18n.te(errorKey) ? i18n.tc(errorKey) : violation.message;
                    fieldErrors[violation.propertyPath].push(errorMessage);
                }
                return {
                    message: i18n.tc('error.validation'),
                    cause: error.cause,
                    fieldErrors,
                };
            }
        }
    }
    if (error instanceof Error) {
        return {
            message: error.message,
            cause: error.cause,
        };
    }
    return { message: i18n.tc('error.default'), cause: error };
}
var ViolationErrorCode;
(function (ViolationErrorCode) {
    ViolationErrorCode["LENGTH_TOO_SHORT"] = "9ff3fdc4-b214-49db-8718-39c315e33d45";
    ViolationErrorCode["LENGTH_TOO_LONG"] = "d94b19cc-114f-4f44-9cc4-4138e80a87b9";
    ViolationErrorCode["LENGTH_NOT_EQUAL_LENGTH"] = "4b6f5c76-22b4-409d-af16-fbe823ba9332";
    ViolationErrorCode["LENGTH_INVALID_CHARACTERS"] = "35e6a710-aa2e-4719-b58e-24b35749b767";
})(ViolationErrorCode || (ViolationErrorCode = {}));
const ERROR_TRANSLATION_KEYS = {
    [ViolationErrorCode.LENGTH_TOO_SHORT]: 'error.length.too_short',
    [ViolationErrorCode.LENGTH_TOO_LONG]: 'error.length.too_long',
    [ViolationErrorCode.LENGTH_NOT_EQUAL_LENGTH]: 'error.length.not_equal_length',
    [ViolationErrorCode.LENGTH_INVALID_CHARACTERS]: 'error.length.invalid_characters',
};
